import React, { useState } from "react";
import Container from "../components/container";
import SEO from "../components/seo";

import { Modal } from "antd";
import TitleBanner from "../components/titleBanner";
import Card from "../components/imageCard";
import LinkNewTab from "../components/LinkNewTab";
import { useStaticQuery, graphql } from "gatsby";

function installInfo() {
  Modal.info({
    title: "How to Install",
    content: (
      <div>
        Replace the Assembly-CSharp.dll in the games' files. ({"<"}
        Game{">"}/{"<"}Game{">"}_Data/Managed/)
      </div>
    ),
    onOk() {},
  });
}

function ModCard({ title, image, buttonLink, children }) {
  return (
    <Card
      title={title}
      image={image}
      buttonText={"Download Mod"}
      buttonLink={buttonLink}
      buttonOnClick={installInfo}
      buttonLinkNewTab={false}
      buttonDownload={true}
    >
      {children}
    </Card>
  );
}

function ModsPage() {
  const data = useStaticQuery(graphql`
    query {
      stickfightImg: file(relativePath: { eq: "stickfight.jpeg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      escapistsImg: file(relativePath: { eq: "theEscapists2.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      stickfightMod: file(
        relativePath: { eq: "mods/StickFight/1.0/Assembly-CSharp.dll" }
      ) {
        publicURL
      }
      escapistsMod: file(
        relativePath: { eq: "mods/TheEscapists2/0.24/Assembly-CSharp.dll" }
      ) {
        publicURL
      }
    }
  `);

  const title = "Mods (for PC)";

  return (
    <Container defKey="3">
      <SEO title={title} />
      <TitleBanner title={title}>
        Here are all my mods I made for various games.
      </TitleBanner>
      <div className="cardsContainer">
        <ModCard
          title="Stick Fight: The Game: Cheat Menu (for v1.0)"
          image={data.stickfightImg.childImageSharp.fluid}
          buttonLink={data.stickfightMod.publicURL}
        >
          Usage: Press the comma key (",") to open the menu.
        </ModCard>
        <ModCard
          title="The Escapists 2: Cheat Menu (for v0.24)"
          image={data.escapistsImg.childImageSharp.fluid}
          buttonLink={data.escapistsMod.publicURL}
        >
          Usage: Press the comma key (",") to open the menu.
        </ModCard>
      </div>
    </Container>
  );
}

export default ModsPage;
